import { useGlobalStore } from '@/features/Global/store';
import type { DISTRIBUTION_STEP, STEP } from '@/router/steps';

export const getRoute = (name: STEP | DISTRIBUTION_STEP): string => {
  const sparte = useGlobalStore().getSparte;

  return `${sparte}.${name}`;
};
